/* Trappbutiken – konfiguratorns fristående UI-script (utflyttade ur sektionen 2026-07-22):
   1) visual-spegling av valt kort, 2) app-läget (footer in i panelen + sidlås).
   Laddas med defer → DOM finns när koden kör. */

/* Visual-spegling: när ett alternativkort väljs i steg 1/2 visas dess bild stort till vänster. */
(function(){
  var root=document.querySelector('.wubs-stairs')||document;
  var vis=root.querySelector('[data-konfig-visual]');
  var img=root.querySelector('[data-konfig-visual-img]');
  if(!vis||!img) return;
  document.addEventListener('click', function(e){
    var card=e.target.closest('.wubs-optcard');
    if(!card) return;
    var step=card.closest('[data-step]');
    if(!step) return;
    var n=step.getAttribute('data-step');
    if(n!=='1' && n!=='2') return;
    var src=(card.querySelector('img')||{}).currentSrc||(card.querySelector('img')||{}).src;
    if(!src||img.src===src) return;
    vis.classList.add('is-swapping');
    setTimeout(function(){ img.src=src; img.onload=function(){ vis.classList.remove('is-swapping'); }; setTimeout(function(){ vis.classList.remove('is-swapping'); },600); },180);
  });
})();


/* Laddar-animation: tona ut den när 3D-canvasen faktiskt finns och målats.
   Bundlen (defer) skapar en <canvas> i [data-konfig-3d] och sätter mount.display=block
   i activate(). Vi väntar på canvasen + två frames (första paint) och sätter is-3d-ready.
   Failsafe: dölj ändå efter 8 s så laddaren aldrig fastnar. */
(function () {
  var vis = document.querySelector('[data-konfig-visual]');
  var mount = document.querySelector('[data-konfig-3d]');
  if (!vis || !mount || !document.querySelector('[data-konfig-loader]')) return;
  var settled = false;
  function ready() {
    if (settled) return;
    settled = true;
    // Kort fördröjning så canvasen hinner måla första bilden innan laddaren tonar bort.
    // (setTimeout, INTE rAF – förhandsvisningspanelen throttlar rAF.)
    setTimeout(function () { vis.classList.add('is-3d-ready'); }, 350);
    if (obs) obs.disconnect();
  }
  function hasCanvas() {
    var c = mount.querySelector('canvas');
    return c && getComputedStyle(mount).display !== 'none';
  }
  var obs = new MutationObserver(function () { if (hasCanvas()) ready(); });
  obs.observe(mount, { childList: true, attributes: true, attributeFilter: ['style'] });
  if (hasCanvas()) ready();
  setTimeout(function () { ready(); }, 8000); // failsafe
})();

  (function () {
    var done = false;
    function activate() {
      if (done || !window.matchMedia('(min-width: 992px)').matches) return;
      var panel = document.querySelector('.wubs-panel');
      if (!panel) return;                            // vänta tills panelen finns
      var hdr = document.querySelector('.wubs-header');
      var hh = hdr ? Math.round(hdr.getBoundingClientRect().bottom) : 112;
      document.documentElement.style.setProperty('--wubs-hh', hh + 'px');
      document.documentElement.classList.add('wubs-appmode');  // lås sidan + dölj footern (CSS)
      done = true;
    }
    activate();
    document.addEventListener('DOMContentLoaded', activate);
    window.addEventListener('load', activate);
    window.addEventListener('resize', activate);
    setTimeout(activate, 300);
    setTimeout(activate, 1200);
  })();
